import React from "react";
import ConditionQuestionsCompactView from "./ConditionQuestionsCompactView";
import { useConditionQuestionsCompactView } from "./useConditionQuestionsCompactView";

export default function ConditionQuestionsCompactViewContainer() {
  const {
    bodyworkQuestion,
    conditionQuestions,
    handleSubmit,
    questionsAndAnswers,
    isContinueClicked,
    modificationQuestion
  } = useConditionQuestionsCompactView();

  return (
    <ConditionQuestionsCompactView
      modificationQuestion={modificationQuestion}
      bodyworkQuestion={bodyworkQuestion}
      conditionQuestions={conditionQuestions}
      onSubmit={handleSubmit}
      questionsAndAnswers={questionsAndAnswers}
      isContinueClicked={isContinueClicked}
    />
  );
}
